import React, { useState, useEffect } from "react";
import ViewUserForm from "./ViewUserForm";
import EditUserForm from "./EditUserForm";
import ResetPin from "./ResetPin";
import AddUserForm from "./AddUserForm";

// Icons
import editIcon from "../assets/icons/EditIcon.svg";
import KeyIcon from "../assets/icons/KeyIcon.svg"; 


const UserSearch = ({ refreshTrigger }) => {
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [transactionHistory, setTransactionHistory] = useState([]);
  const [showUserDataForm, setShowUserDataForm] = useState(false);
  const [showEditUserForm, setShowEditUserForm] = useState(false);
  const [resetUserId, setResetUserId] = useState(null);
  const [showAddUserForm, setShowAddUserForm] = useState(false);

  const fetchUsers = () => {
    fetch("/api/admin/users")
      .then((response) => response.json())
      .then((data) => setUsers(data))
      .catch((error) => console.error("Error fetching users:", error));
  };

  const handleViewUser = (userId) => {
    fetch(`/api/admin/users/${userId}`)
      .then((response) => response.json())
      .then((user) => {
        setSelectedUser(user);
        setShowUserDataForm(true);
      })
      .catch((error) => console.error("Error fetching user details:", error));

    fetch(`/api/admin/users/${userId}/transactions`)
      .then((response) => response.json())
      .then((transactions) => setTransactionHistory(transactions))
      .catch((error) => console.error("Error fetching transaction history:", error));
  };

  const handleResetPin = (userId) => {
    setResetUserId(userId);
  };

  const handleAddUser = () => {
    setShowAddUserForm(true);
  };

  const handleEditUser = (user) => {
    setSelectedUser(user);
    setShowEditUserForm(true);
  };

  const handleSaveUser = () => {
    fetchUsers();
    setShowEditUserForm(false);
  };

  const handleUserAdded = () => {
    fetchUsers();
    setShowAddUserForm(false);
  };

  useEffect(() => {
    fetchUsers();
  }, [refreshTrigger]);

  const filteredUsers = users.filter((user) =>
    (user.first_name?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.last_name?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.email?.toLowerCase() || "").includes(searchQuery.toLowerCase()) ||
    (user.phone?.toLowerCase() || "").includes(searchQuery.toLowerCase())
  );

  return (
    <div className="user-list-container">
      <div className="search-header-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '20px' }}>
        <div className="search-group">
          <label>Search Users:</label>
          <input
            type="text"
            placeholder="Search name, email, or phone..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: '300px', display: 'block', marginTop: '5px' }}
          />
        </div>
        <div className="button-container" style={{ margin: 0 }}>
          <button className="add-user-button" onClick={handleAddUser}>+ Add User</button>
        </div>
      </div>

      <div className="UserList-container">
        <table>
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Mobile</th>
              <th>Access Level</th>
              <th style={{ textAlign: 'center' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <tr key={user.user_id || user.phone}>
                  <td>{user.first_name}</td>
                  <td>{user.last_name}</td>
                  <td>{user.email}</td>
                  <td>{user.phone}</td>
                  <td>{user.role_name || "N/A"}</td>
                  <td className="action-cell">
                    <div className="action-wrapper">
                     

                      {/* Edit Action */}
                      <button 
                        className="icon-action-btn" 
                        onClick={() => handleEditUser(user)}
                        title="Edit User"
                      >
                        <img src={editIcon} alt="Edit" className="table-icon" />
                      </button>

                      {/* Reset Pin Action */}
                      <button 
                        className="icon-action-btn" 
                        onClick={() => handleResetPin(user.user_id)}
                        title="Reset PIN"
                      >
                        <img src={KeyIcon} alt="Reset Pin" className="table-icon" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>
                  No users match your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modals */}
      {showUserDataForm && selectedUser && (
        <ViewUserForm
          selectedUser={selectedUser}
          transactionHistory={transactionHistory}
          onClose={() => setShowUserDataForm(false)}
        />
      )}

      {showEditUserForm && selectedUser && (
        <EditUserForm
          user={selectedUser}
          onClose={() => setShowEditUserForm(false)}
          onSave={handleSaveUser}
        />
      )}

      {resetUserId && (
        <ResetPin userId={resetUserId} onClose={() => setResetUserId(null)} />
      )}

      {showAddUserForm && (
        <AddUserForm
          onClose={() => setShowAddUserForm(false)}
          onUserAdded={handleUserAdded}
        />
      )}
    </div>
  );
};

export default UserSearch;